<dojo-simple-solver
  [slide]="slide()"
  [config]="config()"
  [resizable]="editor().isEditable"
  (widthChange)="onWidthChange($event)"
/>
